import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import HeroBackground from './HeroBackground';

const defaultShellSx = {
  position: 'relative',
  height: { xs: '50vh', sm: '60vh', md: '70vh' },
  minHeight: { xs: 300, sm: 400, md: 500 },
  overflow: 'hidden',
};

const PageHero = ({ src, alt, title, subtitle, priority = false, shellSx, children }) => (
  <Box sx={{ ...defaultShellSx, ...shellSx }}>
    <HeroBackground src={src} alt={alt} priority={priority}>
      <Container
        maxWidth="lg"
        sx={{
          position: 'relative',
          zIndex: 2,
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box sx={{ textAlign: 'center', color: 'white', width: '100%' }}>
          {children || (
            <>
              <Typography
                variant="h2"
                component="h1"
                gutterBottom
                sx={{
                  fontWeight: 'bold',
                  fontSize: { xs: '2rem', sm: '3rem', md: '4rem' },
                  textShadow: '0px 2px 4px rgba(0,0,0,0.3)',
                  mb: 2,
                }}
              >
                {title}
              </Typography>
              {subtitle && (
                <Typography
                  variant="h5"
                  sx={{
                    opacity: 0.95,
                    fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.5rem' },
                    textShadow: '0px 1px 2px rgba(0,0,0,0.3)',
                    maxWidth: 800,
                    mx: 'auto',
                    lineHeight: 1.4,
                  }}
                >
                  {subtitle}
                </Typography>
              )}
            </>
          )}
        </Box>
      </Container>
    </HeroBackground>
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background:
          'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.05"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
        opacity: 0.3,
        zIndex: 1,
        pointerEvents: 'none',
      }}
    />
  </Box>
);

export default PageHero;
